import { getNetworkPassphrase } from 'helpers/env';

import type * as Sdk from './aquariusSdk';

let modulePromise: Promise<typeof Sdk>;

const load = async () => {
    const network = getNetworkPassphrase();
    modulePromise ??= import('./aquariusSdk').catch(error => {
        modulePromise = undefined;
        throw error;
    });
    const sdk = await modulePromise;
    if (network !== getNetworkPassphrase()) {
        throw new Error('Network changed while loading the SDK. Please try again.');
    }
    return sdk;
};

export const getAquariusClient = async (...args: Parameters<typeof Sdk.getAquariusClient>) =>
    (await load()).getAquariusClient(...args);

export const getAquariusPool = async (...args: Parameters<typeof Sdk.getAquariusPool>) =>
    (await load()).getAquariusPool(...args);

export const toAquariusAsset = async (...args: Parameters<typeof Sdk.toAquariusAsset>) =>
    (await load()).toAquariusAsset(...args);
